import { render } from "./ImageContentPluginForm.vue?vue&type=template&id=c87dec4c"
import script from "./ImageContentPluginForm.vue?vue&type=script&lang=js"
export * from "./ImageContentPluginForm.vue?vue&type=script&lang=js"

import "./ImageContentPluginForm.vue?vue&type=style&index=0&id=c87dec4c&lang=css"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__